import {
  EnergySavingsLeaf as EcoIcon,
  HourglassBottom as BalanceIcon,
  Speed as SpeedIcon,
} from "@mui/icons-material";

export const DEVICE_MODES_CONST = {
  ECO: {
    id: "eco",
    name: "Eco Mode",
    interval: "15 minutes",
    color: "#7ecc8e", // Verde pastel fuerte
    icon: EcoIcon,
    description: "Energy efficient mode with updates every 15 minutes",
  },
  BALANCED: {
    id: "balanced",
    name: "Balanced Mode",
    interval: "7 minutes",
    color: "#ffb961", // Naranja pastel fuerte
    icon: BalanceIcon,
    description: "Balanced performance with updates every 7 minutes",
  },
  REALTIME: {
    id: "realtime",
    name: "Real-time Mode",
    interval: "1 minute",
    color: "#f27c7c", // Rosa pastel fuerte
    icon: SpeedIcon,
    description: "High performance mode with updates every 1 minute",
  },
};


export const getModeById = (id) => {
  return Object.values(DEVICE_MODES_CONST).find(mode => mode.id === id) || DEVICE_MODES_CONST.BALANCED;
};

// Constantes para facilitar el uso
export const DEVICE_MODES = {
  ECO: "eco",
  BALANCED: "balanced",
  REALTIME: "realtime",
};

export const DEVICE_STATUS = {
  PENDING: "pending",
  LINKED: "linked",
  UNLINKED: "unlinked",
};